exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1BTFPOtHu13Yo75zc6Ytay .btn,\n._1BTFPOtHu13Yo75zc6Ytay .form-control {\n  height: calc(2.5714286rem + 0.125rem + 0rem) !important;\n}\n", ""]);
// Exports
exports.locals = {
	"daterangepicker": "_1BTFPOtHu13Yo75zc6Ytay"
};